<script setup lang="ts">
const {collectionUri, pageUri} = useI18nCollection();
const page = await queryCollection(collectionUri('brands')).path(pageUri('/brands')).first();
</script>

<template>
  <div>
    <NuxtLayout name="page-with-banner" :page="page">
      <SectionBrands />
    </NuxtLayout>
  </div>
</template>
